<template>
    <div class="submodule-loader">
        <component v-if="loadedComponent" :is="loadedComponent" />
        <div v-else-if="loadError" class="submodule-error">
            <div class="error-container">
                <h3>플러그인 로드 실패</h3>
                <p><strong>플러그인:</strong> {{ pluginName }}</p>
                <p><strong>에러:</strong> {{ loadError }}</p>
                <button class="btn btn-primary" @click="reload">다시 시도</button>
            </div>
        </div>
        <div v-else class="submodule-loading">로딩 중...</div>
    </div>
</template>

<script>
const COMPONENT_NAME = "Main.vue";

export default {
    name: "SubmoduleLoader",
    props: {
        pluginName: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            loadedComponent: null,
            loadError: null,
        };
    },
    computed: {
        effectivePluginName() {
            return this.pluginName || (this.$route && this.$route.params && this.$route.params.pluginName) || "";
        },
    },
    watch: {
        effectivePluginName: {
            immediate: true,
            handler(name) {
                if (name) {
                    this.loadComponent(name);
                } else {
                    this.loadedComponent = null;
                    this.loadError = "플러그인 이름이 없습니다.";
                }
            },
        },
    },
    methods: {
        loadComponent(pluginName) {
            this.loadedComponent = null;
            this.loadError = null;
            try {
                const context = require.context("@/submodules", true, /\.vue$/);
                const componentPath = `./${pluginName}/${COMPONENT_NAME}`;
                const module = context(componentPath);
                if (module && module.default) {
                    this.loadedComponent = module.default;
                } else {
                    this.loadError = `컴포넌트를 찾을 수 없습니다: ${pluginName}/${COMPONENT_NAME}`;
                }
            } catch (e) {
                console.error(`Submodule ${pluginName} 로드 실패:`, e);
                this.loadError = e.message || "로드 실패";
            }
        },
        reload() {
            this.loadComponent(this.effectivePluginName);
        },
    },
};
</script>

<style scoped>
.submodule-loader {
    min-height: 200px;
}
.submodule-error,
.submodule-loading {
    padding: 2rem;
    text-align: center;
}
.error-container {
    max-width: 480px;
    margin: 0 auto;
}
</style>
